export default "__VITE_ASSET__161c3188__"